<template>
  <div class="container">
    <div class="personal-info" @click.stop="toggleOverlay">
      <img class="head-portrait" v-if="headerUrl" :src="headerUrl" />
      <div class="triangle" :class="{ active: isOverlayVisible }"></div>
    </div>

    <div
      class="van-overlay"
      v-show="isOverlayVisible"
      @click.self="isOverlayVisible = false"
    >
      <div class="family-info">
        <div class="family-info-item active">
          <div class="family-info-item-l">{{ userInfo.nickname }}</div>
          <img
            src="@/accesst/index/family-info-item-r-img.png"
            alt=""
            srcset=""
            class="family-info-item-r"
          />
        </div>
        <div class="family-info-item-line"></div>
        <div class="family-info-item" @click="goFamilyList">
          <div class="family-info-item-l">家庭管理</div>
          <img
            src="@/accesst/index/family-info-item-r-s-img.png"
            alt=""
            srcset=""
            class="family-info-item-r"
          />
        </div>
      </div>
    </div>

    <!-- 头部 -->
    <div class="header"></div>
    <div class="h35"></div>
    <bar />
    <!-- 未绑定设备 start-->
    <div v-show="hasDevice === false" class="h35"></div>
    <div v-show="hasDevice === false" class="no-bind">
      <div class="h15"></div>
      <img
        @click="gotoBind"
        src="@/accesst/index/bind.png"
        class="bind-img"
        alt=""
        srcset=""
      />
      <div class="bind-tip">您还没有绑定设备，请绑定</div>
    </div>
    <!-- 未绑定设备 end-->
    <!-- 绑定设备后无数据 start-->
    <div v-show="hasAI === false" class="h35"></div>
    <div v-show="hasAI === false" class="no-data">
      <div class="no-data-header">
        <div class="no-data-header-l">未获取到检测结果</div>
        <userDeviceListVue
          @changeForm="changeForm"
          v-if="deviceUsers"
          :list="deviceUsers"
          :form="deviceUserForm"
        />
        <div v-else>&nbsp;</div>
      </div>
      <div class="no-data-empty">
        <van-empty
          :description="`请用${
            deviceUserForm.userName || '用户1'
          }进行AI检查，检测完成后数据会自动同步`"
        />
      </div>
    </div>
    <!-- 绑定设备后无数据 end-->
    <!-- 第一次检测 start -->
    <div v-if="aiCheckList.length === 1" class="h35"></div>
    <div v-show="aiCheckList.length === 1" class="no-data">
      <div class="no-data-header">
        <div class="no-data-header-l">{{ checkPrompt }}</div>
        <userDeviceListVue
          @changeForm="changeForm"
          v-if="deviceUsers"
          :list="deviceUsers"
          :form="deviceUserForm"
        />
        <div v-else>&nbsp;</div>
      </div>
      <div v-if="aiCheckList.length === 1" class="check-list">
        <div class="check-info">
          <div class="check-info-item">
            <span>双眼： {{ aiCheckList[0].eyeTwoVal }}</span>
            <img
              v-if="aiCheckList[0].eyeTwoComp < 0"
              src="@/accesst/check/down.png"
              alt=""
              srcset=""
            />
            <img
              v-if="aiCheckList[0].eyeTwoComp > 0"
              src="@/accesst/check/up.png"
              alt=""
              srcset=""
            />
            <img
              v-if="
                aiCheckList[0].eyeTwoComp == 0 ||
                aiCheckList[0].eyeTwoComp == null
              "
              src="@/accesst/check/hr.png"
              alt=""
              srcset=""
            />
            {{
              aiCheckList[0].eyeTwoComp == 0 ||
              aiCheckList[0].eyeTwoComp == null
                ? "与平均值持平"
                : aiCheckList[0].eyeTwoComp > 0
                ? "高于平均值" + aiCheckList[0].eyeTwoComp + "%"
                : "低于平均值" + aiCheckList[0].eyeTwoComp * -1 + "%"
            }}
          </div>
          <div class="check-info-line"></div>
          <div class="check-info-item">
            <span>左眼： {{ aiCheckList[0].eyeLeftVal }}</span>
            <img
              v-if="aiCheckList[0].eyeLeftComp < 0"
              src="@/accesst/check/down.png"
              alt=""
              srcset=""
            />
            <img
              v-if="aiCheckList[0].eyeLeftComp > 0"
              src="@/accesst/check/up.png"
              alt=""
              srcset=""
            />
            <img
              v-if="
                aiCheckList[0].eyeLeftComp == 0 ||
                aiCheckList[0].eyeLeftComp == null
              "
              src="@/accesst/check/hr.png"
              alt=""
              srcset=""
            />
            {{
              aiCheckList[0].eyeLeftComp == 0 ||
              aiCheckList[0].eyeLeftComp == null
                ? "与平均值持平"
                : aiCheckList[0].eyeLeftComp > 0
                ? "高于平均值" + aiCheckList[0].eyeLeftComp + "%"
                : "低于平均值" + aiCheckList[0].eyeLeftComp * -1 + "%"
            }}
          </div>
          <div class="check-info-line"></div>
          <div class="check-info-item">
            <span>右眼： {{ aiCheckList[0].eyeRightVal }}</span>
            <img
              v-if="aiCheckList[0].eyeRightComp < 0"
              src="@/accesst/check/down.png"
              alt=""
              srcset=""
            />
            <img
              v-if="aiCheckList[0].eyeRightComp > 0"
              src="@/accesst/check/up.png"
              alt=""
              srcset=""
            />
            <img
              v-if="
                aiCheckList[0].eyeRightComp == 0 ||
                aiCheckList[0].eyeRightComp == null
              "
              src="@/accesst/check/hr.png"
              alt=""
              srcset=""
            />
            {{
              aiCheckList[0].eyeRightComp == 0 ||
              aiCheckList[0].eyeRightComp == null
                ? "与平均值持平"
                : aiCheckList[0].eyeRightComp > 0
                ? "高于平均值" + aiCheckList[0].eyeRightComp + "%"
                : "低于平均值" + aiCheckList[0].eyeRightComp * -1 + "%"
            }}
          </div>
        </div>
        <div class="check-tip-info">
          <div class="check-tip-title">
            <template v-if="totalCheckResultComp > 0">
              当前视力高于平均水平
            </template>
            <template v-if="totalCheckResultComp < 0">
              当前视力低于平均水平
            </template>
            <template v-if="totalCheckResultComp == 0">
              当前视力与平均水平持平
            </template>
            <!-- <span v-show="totalCheckResultComp < 0" style="color: #E90000">
              约{{ totalCheckResultComp * -1 }}
            </span>
            <span v-show="totalCheckResultComp > 0" style="color: #13A663">
              约{{ totalCheckResultComp }}
            </span> -->
            <img
              v-show="totalCheckResultComp < 0"
              src="@/accesst/check/xia.png"
              style="width: 0.25rem"
              alt=""
              srcset=""
            />
            <img
              v-show="totalCheckResultComp > 0"
              src="@/accesst/check/shang.png"
              style="width: 0.25rem"
              alt=""
              srcset=""
            />
          </div>
          <div class="check-tip-des">
            *检测数据仅作参考，如有眼部疾病请及时就医确诊
          </div>
        </div>
      </div>
      <div class="h35"></div>
      <moreCheckE
        v-if="aiCheckList.length === 1"
        ref="firstMoreCheckE"
        :form="deviceUserForm"
        key="first-check-e"
        id="first-check-e"
      />
      <!-- <div class="h35"></div> -->
    </div>
    <!-- 第一次检测 End -->
    <!-- 多次检测 start -->
    <div v-if="aiCheckList.length > 1" class="h35"></div>
    <div v-show="aiCheckList.length > 1" class="no-data">
      <div class="no-data-header">
        <div class="no-data-header-l">{{ checkPrompt }}</div>
        <userDeviceListVue
          @changeForm="changeForm"
          v-if="deviceUsers"
          :list="deviceUsers"
          :form="deviceUserForm"
        />
        <div v-else>&nbsp;</div>
      </div>
      <div class="h35"></div>
      <!--对比图标 -->
      <div class="contrast-echart">
        <contrast
          :_aiCheckList="aiCheckList"
          :tipInfo="tipInfo"
          :form="deviceUserForm"
        ></contrast>
      </div>
      <div class="h35"></div>
      <moreCheckE2
        v-if="aiCheckList.length > 1"
        ref="moreCheckE"
        :stack="'total'"
        :form="deviceUserForm"
        key="more-check-e"
        id="more-check-e"
      />
      <!-- <div class="h35"></div> -->
    </div>
    <!-- 多次检测 end -->
    <!-- 快速入口 -->
    <!-- <div class="h35"></div> -->
    <div class="h35"></div>
    <!-- 排行榜 -->
    <rank />
    <div class="h35"></div>
  </div>
</template>
<script>
import { isArray, groupBy, forEach } from "lodash";
import bar from "@/view/components/bar.vue";
import rank from "@/view/components/rank.vue";
import userDeviceListVue from "@/view/components/userDeviceList.vue";
import indexProgressVue from "./components/indexProgress.vue";
import firstCheckE from "@/view/components/firstCheckE.vue";
import moreCheckE from "@/view/components/moreCheckE.vue";
import contrast from "@/view/components/contrast.vue";
import { Empty } from "vant";
import {
  getUserInfo,
  bindDevicePage,
  deviceUserPage,
  getUserAiCheck,
  deviceNewUserPage,
} from "@/api/h5";
import { getFamilyInfo } from "@/api/family";
import moreCheckE2 from "./components/moreCheckE-2.vue";
export default {
  components: {
    bar,
    rank,
    userDeviceListVue,
    indexProgressVue,
    firstCheckE,
    contrast,
    moreCheckE,
    moreCheckE2,
    [Empty.name]: Empty,
  },
  data() {
    return {
      isOverlayVisible: false, // 控制显示状态
      hasDevice: null, // 是否绑定设备
      hasAI: null, // 是否有AI检测数据
      aiCheckList: [],
      checkPrompt: "",
      totalCheckResultVal: "",
      totalCheckResultComp: 0,
      deviceUserForm: {
        deviceId: "",
        deviceUserId: "",
      },
      deviceUsers: null,
      headerUrl: "",
      tipInfo: {},
      step: 1,
      showStep: false,
      showFamily: false,
      userInfo: {},
      haveFamily: false,
      familyInfo: {
        curMember: {
          role: "",
        },
      },
    };
  },
  created() {
    this.indexGetUserInfo();
  },
  mounted() {
    // this.yinDao()
    this.getUserInfoFn();
    this.getFamilyInfoFn();
    // 1. 获取当前用户绑定设备的列表 判断是否绑定过设备
    bindDevicePage({}).then((res) => {
      console.log(res, "bindDevicePage");
      if (res.total && res.list && res.list.length) {
        this.hasDevice = true;
        // 2. 查询 设备<--->使用者列表
        deviceNewUserPage({
          pageSize: 100,
        }).then((dusers) => {
          console.log(dusers, "设备<--new ->使用者列表");
          if (dusers && dusers.list && dusers.list.length) {
            const deviceUsers = dusers.list;
            const curDeviceSnAndUuid = dusers.curDeviceSnAndUuid || {};
            console.log(
              find(deviceUsers, ["uuid", curDeviceSnAndUuid.uuid]),
              curDeviceSnAndUuid.uuid
            );
            let defaultUser =
              find(deviceUsers, ["uuid", curDeviceSnAndUuid.uuid]) ||
              deviceUsers[0];
            this.deviceUserForm.deviceUserId = defaultUser.uuid;
            this.deviceUserForm.userName = defaultUser.name;
            console.log(deviceUsers, this.deviceUserForm, "--deviceUsers---");
            this.deviceUsers = deviceUsers;
            this.initData();
          }
        });
      } else {
        this.hasDevice = false;
      }
    });
  },
  methods: {
    gotoBind() {
      window.location.href = "/deviceBind"; // 强制刷新页面，保证签名URL一致
    },
    goFamilyList() {
      if (this.haveFamily) {
        this.$router.push({
          name: "familyList",
        });
      }
    },
    getUserInfoFn() {
      getUserInfo({}).then((res) => {
        this.userInfo = res;
      });
    },
    changeForm(form) {
      console.log("changeForm", form);
      this.deviceUserForm = {
        ...this.deviceUserForm,
        ...form,
      };
      this.initData();
    },
    indexGetUserInfo() {
      console.log("indexGetUserInfo");
      getUserInfo({}).then((res) => {
        this.headerUrl = res.avatar;
      });
    },
    toggleOverlay() {
      this.isOverlayVisible = !this.isOverlayVisible;
    },
    getFamilyInfoFn() {
      getFamilyInfo({}).then((res) => {
        if (res) {
          this.familyInfo = res;
          this.haveFamily = true;
          localStorage.setItem(
            "userInfo",
            JSON.stringify({
              ...res.curMember,
              familyName: res.familyName,
            })
          );
        } else {
          this.haveFamily = false;
        }
      });
    },
    initData() {
      // this.$refs['firstMoreCheckE'].init(this.deviceUserForm);
      // this.$refs['moreCheckE'].init(this.deviceUserForm);
      // 3. 查询 AI检测 查询 护眼计划
      getUserAiCheck({
        uuid: this.deviceUserForm.deviceUserId,
      }).then((res) => {
        console.log(res, "AI 检测数据");
        if (res && res.aiCheckList && res.aiCheckList.length) {
          this.aiCheckList.length = 0;
          this.aiCheckList = res.aiCheckList;
          this.checkPrompt = res.checkPrompt;
          this.totalCheckResultVal = res.totalCheckResultVal;
          this.totalCheckResultComp = res.totalCheckResultComp || 0;
          this.tipInfo = {
            checkPrompt: res.checkPrompt || "",
            totalCheckResultComp: res.totalCheckResultComp || 0,
            totalCheckResultVal: res.totalCheckResultVal || "",
          };
          this.hasAI = true;
        } else {
          this.aiCheckList.length = 0;
          this.checkPrompt = "";
          this.hasAI = false;
          this.tipInfo = {};
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100vw;
  min-height: 100vh;

  // nav
  .personal-info {
    box-sizing: border-box;
    height: 0.86rem;
    width: 100vw;
    padding-left: 0.28rem;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    background: linear-gradient(180deg, #f6f6f6 20%, #eee);
    border-radius: 0 0 0.16rem 0.16rem;
    box-shadow: 0 0.02rem 0.04rem 0 rgba(0, 0, 0, 0.2);

    //头像
    .head-portrait {
      width: 0.52rem;
      height: 0.52rem;
      border-radius: 50%;
      border: 0.02rem solid #e9e9e9;
      display: block;
    }

    //箭头
    .triangle {
      width: 0;
      height: 0;
      border-left: 0.06rem solid transparent;
      border-right: 0.06rem solid transparent;
      border-top: 0.06rem solid #000;
      margin-left: 0.14rem;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;

      &.active {
        transform: rotate(180deg);
      }
    }
  }

  //家庭管理
  .van-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);

    .family-info {
      width: 4.14rem;
      background: #fff;
      border-radius: 0.3rem;
      position: absolute;
      left: 0.6rem;
      top: 0.86rem;
      overflow: hidden;

      .family-info-item {
        height: 1.16rem;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        justify-content: space-between;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        padding: 0 0.36rem;

        .family-info-item-l {
          font-size: 0.3rem;
          font-weight: 400;
          color: #393939;
        }

        .family-info-item-r {
          width: 0.4rem;
          height: 0.4rem;
        }

        &.active {
          background: #e5f7fa;
        }
      }
    }
  }

  .contrast-echart {
    width: 6.9rem;
    height: 5.19rem;
    border-radius: 0.12rem;
    border: 0.02rem solid #eeeeee;
  }

  .check-list {
    margin: 0.23rem auto 0;
    width: 6.92rem;
    // height: 3.81rem;
    background: #f7f8fe;
    border-radius: 0.1rem;

    .check-info {
      padding: 0 0.3rem;

      .check-info-item {
        height: 0.88rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 0.27rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #000000;

        span {
          width: 1.85rem;
        }

        img {
          width: 0.31rem;
          margin: 0 0.8rem 0 0.2rem;
        }
      }

      .check-info-line {
        height: 0.02rem;
        background: #eeeeee;
      }
    }

    .check-tip-info {
      width: 100%;
      height: 1.31rem;
      background: url("../accesst/check/bg.png") no-repeat;
      background-size: 100% 1.31rem;
      border-radius: 0 0 0.12rem 0.12rem;

      .check-tip-title {
        padding: 0.2rem 0 0 0.27rem;
        font-size: 0.31rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #2b67d9;
      }

      .check-tip-des {
        padding: 0.12rem 0 0 0.27rem;
        font-size: 0.23rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #b9c2d5;
      }
    }
  }

  /deep/ .van-empty__image {
    width: 1.5rem;
    height: auto;
  }

  /deep/ .van-empty__description {
    font-size: 0.23rem;
    padding: 0;
    margin-top: 0.3rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #999999;
  }

  .no-data {
    padding: 0 0.29rem;

    .no-data-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-items: center;
      padding: 0.3rem 0.3rem 0.2rem;
      background: #e2ecff;
      border-radius: 0.12rem 0.12rem 0 0;

      .no-data-header-l {
        font-size: 0.25rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #000000;
      }
    }

    .no-data-empty {
      // margin: .23rem auto;
      width: 6.92rem;
      height: 3.75rem;
      background: linear-gradient(180deg, #fbfbfb 0%, #f6f6f6 100%);
      border-radius: 0.12rem;
    }
  }

  .header {
    margin: 0.23rem auto 0;
    width: 6.92rem;
    height: 2.5rem;
    border-radius: 0.12rem;
    background: url("../accesst/index/ouou-banner-new.jpg") no-repeat;
    background-size: 6.92rem 2.5rem;
  }

  .h35 {
    height: 0.35rem;
  }

  .h15 {
    height: 0.15rem;
  }

  .no-bind {
    margin: 0 auto;
    width: 6.92rem;
    height: 3.75rem;
    background: linear-gradient(180deg, #fbfbfb 0%, #f6f6f6 100%);
    border-radius: 0.12rem;

    .bind-img {
      display: block;
      width: 4.46rem;
      height: 2.5rem;
      margin: 0 auto;
    }

    .bind-tip {
      height: 0.33rem;
      font-size: 0.23rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 0.33rem;
      text-align: center;
    }
  }
}
</style>
